export var DetectorType;
(function (DetectorType) {
    DetectorType["Malware"] = "MALWARE";
    DetectorType["RansomwareBehavior"] = "RANSOMWARE_BEHAVIOR";
    DetectorType["DataAnomaly"] = "DATA_ANOMALY";
})(DetectorType || (DetectorType = {}));
